import { render, staticRenderFns } from "./search-view.vue?vue&type=template&id=33f0135d&"
import script from "./search-view.vue?vue&type=script&lang=js&"
export * from "./search-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports